import { Form, Row, Col } from "react-bootstrap";
import { TextField, InputLabel } from "@mui/material";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";

export default function TaskChatForm({
  userData,
  title,
  content,
  error,
  handleTitleChange,
  handleContentChange,
  handleSubmit,
}) {
  return (
    <>
      <Row style={{ marginBottom }}>
        <Col>
          <InputLabel id="content-label">
            Korespondencja od: <b>{userData.fullName}</b>
          </InputLabel>
          <Form.Group controlId="formTitle">
            <TextField
              type="text"
              name="title"
              label="Temat korespondencji"
              fullWidth
              variant="outlined"
              value={title}
              onChange={handleTitleChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ marginBottom }}>
        <Col style={{ marginBottom }}>
          <Form.Group controlId="formContent">
            <TextField
              type="text"
              name="content"
              label="Treść korespondencji"
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={content}
              onChange={handleContentChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Form.Group>
          <br />
          <Button type="submit" variant="outlined" onClick={handleSubmit}>
            Wyślij
          </Button>
        </Col>
      </Row>
    </>
  );
}
